/**
 * Picks v2 or v1 of the API Keys list based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ApiKeysPage   from './ApiKeysPage';
import ApiKeysPageV2 from './v2/ApiKeysPageV2';

export default function ApiKeysPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ApiKeysPageV2 : ApiKeysPage;
  return <Component {...props} />;
}
